import Slider from '../app/slider.js';
import app from '../app.js';
import verticalCenter from '../util/verticalCenter.js';
import equalHeight from '../util/equalHeight.js';

export default {
    init() {
        // JavaScript to be fired on all pages
        app.campaignMonitor();
        verticalCenter('.vertical-center');
        equalHeight('article.product-category');
        // equalHeight('article.type-product.search');
        jQuery('[data-toggle="tooltip"]').tooltip();
        jQuery('img[data-original]').lazyload({
            load: (item) => {
                const container = jQuery(item).parents('.media-container');
                if (container.length > 0) {
                    container.isotope('layout');
                }
            },
        });
        app.productSearch();
        jQuery('a[href$=".pdf"]').attr('download', '');
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        new Slider('section.testimonials', {
            dots: false,
            autoplaySpeed: 1000,
        });

        new Slider('section.manufacturers', {
            dots: false,
            autoplay: true,
            autoplayTimeout: 2000,
            autoplaySpeed: 1000,
            responsive: {
                0: {
                    items: 2,
                },
                450: {
                    items: 3,
                },
                768: {
                    items: 4,
                },
                980: {
                    loop: true,
                    autoplay: true,
                    items: 5,
                },
            },
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/Common.js